// AnalysisPage.jsx
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "./Survey.css";

function AnalysisPage() {
  const { id } = useParams(); // This is the survey ID in the route
  const [analysis, setAnalysis] = useState(null);
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    const fetchAnalysis = async () => {
      try {
        const token = localStorage.getItem("authToken");
        if (!token) {
          setErrorMsg("You must be logged in.");
          setLoading(false);
          return;
        }
        const res = await fetch(`/analysis/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (!res.ok) {
          const errData = await res.json();
          setErrorMsg(errData.error || "Error loading analysis");
          setLoading(false);
          return;
        }
        const data = await res.json();
        setAnalysis(data);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching analysis:", err);
        setErrorMsg("Server error fetching analysis");
        setLoading(false);
      }
    };

    fetchAnalysis();
  }, [id]);

  if (loading) {
    return <div className="survey-container">Loading analysis...</div>;
  }

  if (errorMsg) {
    return (
      <div>
        <h1>AI Analysis</h1>
        <p style={{ color: "red" }}>{errorMsg}</p>
      </div>
    );
  }

  if (!analysis) {
    return <div className="survey-container">No analysis data available.</div>;
  }

  // Destructure all the fields from the JSON we returned
  const {
    bulletPoints,
    actionableInsights,
    summaryText,
    topWords,
    surveyTitle,    // newly added
    responseCount,  // newly added
  } = analysis;

  return (
    <div className="survey-container">
      <h1 className="analysis-title">AI Analysis</h1>
      {/* Instead of Survey ID, show the Survey Title */}
      <h4>Survey Title: {surveyTitle}</h4>
      {/* Show the number of responses */}
      <p>Number of Responses: {responseCount}</p>

      <section style={{ marginTop: "1rem" }}>
        <h3>Key Bullet Points</h3>
        <ul>
          {bulletPoints &&
            bulletPoints.map((bp, idx) => (
              <li key={idx}>{bp}</li>
            ))}
        </ul>
      </section>

      <section style={{ marginTop: "1rem" }}>
        <h3>Actionable Insights</h3>
        <ul>
          {actionableInsights &&
            actionableInsights.map((insight, idx) => (
              <li key={idx}>{insight}</li>
            ))}
        </ul>
      </section>

      <section style={{ marginTop: "1rem" }}>
        <h3>Overall Summary</h3>
        <p>{summaryText}</p>
      </section>

      <section style={{ marginTop: "1rem" }}>
        <h3>Top Words</h3>
        {/* Sort the topWords array by count in descending order */}
        {topWords &&
          [...topWords]
            .sort((a, b) => b.count - a.count)
            .map((w, idx) => (
              <div key={idx}>
                {w.word}: {w.count}
              </div>
            ))}
      </section>
    </div>
  );
}

export default AnalysisPage;
